import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useFetcher, useLocation } from 'react-router';

import Button from 'honeydew/Button';
import TextField from 'honeydew/TextField';
import usePhoneField from 'hooks/usePhoneField';
import profileStyles from 'pages/account/Profile/styles';
import { getFormattedPhoneForDisplay, getHasPhoneNumber } from 'utils/addressUtils';

export default function Phone({ subscription }) {
    const phone = subscription?.shippingAddr?.phone;
    const [isEditing, setIsEditing] = useState(false);
    const location = useLocation();
    const from = location?.state?.from;

    useEffect(() => {
        if (from === 'notifications') setIsEditing(true);
    }, [from]);

    return isEditing ? (
        <div className={profileStyles.editContainer}>
            <Form subscriptionID={subscription?.id} address={subscription?.shippingAddr} setIsEditing={setIsEditing} />
            <button type="button" className={profileStyles.cancel} onClick={() => setIsEditing(false)}>
                Cancel
            </button>
        </div>
    ) : (
        <div className={profileStyles.displayContainer}>
            <div>
                <h4 className="font-grotesk-bold">Phone number</h4>
                {subscription?.id && (
                    <p className="mt-10">
                        {getHasPhoneNumber(phone)
                            ? getFormattedPhoneForDisplay(phone)
                            : 'Add a phone number to receive updates'}
                    </p>
                )}
            </div>
            <button className={profileStyles.edit} type="button" onClick={() => setIsEditing(true)}>
                Edit
            </button>
        </div>
    );
}

Phone.propTypes = {
    subscription: PropTypes.shape({}),
};

Phone.defaultProps = {
    subscription: {},
};

function Form({ address, setIsEditing, subscriptionID }) {
    const fetcher = useFetcher();
    const { phoneFieldProps, phoneFieldValue } = usePhoneField(address?.phone);
    const isBusy = fetcher.state !== 'idle' && !fetcher.data?.error;

    useEffect(() => {
        if (fetcher.data?.success && fetcher.state === 'idle') {
            setIsEditing(false);
        }
    }, [fetcher]);

    return (
        <fetcher.Form action="." method="post" className="block grow">
            <fieldset>
                <TextField
                    name="phone"
                    id="phone"
                    value={phoneFieldValue}
                    {...phoneFieldProps}
                    error={fetcher?.data?.error}
                    errorMsg={fetcher?.data?.message}
                />
                <Link to="/account/notifications#text-preferences">
                    <p className="link text-body-sm mb-20">Manage my text message preferences</p>
                </Link>
                <input type="hidden" name="subscriptionID" defaultValue={subscriptionID} />
                {/* NOTE: there is no stand-alone endpoint to update phone number.
                    So we are passing all shipping address fields back to the API in order to update phone number. */}
                {Object.keys(address)
                    .filter((addressKey) => addressKey !== 'phone')
                    .map((key) => (
                        <input key={key} type="hidden" name={key} value={address[key] ?? ''} />
                    ))}

                <Button type="submit" disabled={isBusy} name="_action" value="updatePhone">
                    {isBusy ? 'Saving...' : 'Save'}
                </Button>
            </fieldset>
        </fetcher.Form>
    );
}

Form.propTypes = {
    address: PropTypes.shape({}).isRequired,
    setIsEditing: PropTypes.func.isRequired,
    subscriptionID: PropTypes.number.isRequired,
};
